export default __webpack_public_path__ + "static/media/logo.b5bb1b92.png";